module.exports = __webpack_public_path__ + "static/media/check.3c562190.svg";